import { BusinessProfile } from "../../interfaces/BusinessObject";
import { VisitingCardDetails } from "../../interfaces/VisitingCardObject";

/**
 * What the visiting card form starts with for a business: the card captured at
 * draft creation, field by field, else the business's own phone / address /
 * email. Older businesses (no stored card) get the plain business details.
 */
export function resolveVisitingCardDefaults(
  business: Pick<BusinessProfile, "phone" | "address" | "email" | "visitingCard"> | null | undefined
): VisitingCardDetails {
  const card = business?.visitingCard;
  return {
    phones: card?.phones.length ? card.phones : [business?.phone || ""],
    address: card?.address || business?.address || "",
    email: card?.email || business?.email || undefined,
  };
}
